import React from "react";
import { Grid, Typography } from "@material-ui/core";

export default ({ children }) => (
  <Grid container justifyContent="center" spacing={4}>
    <Grid item xs={12} />
    <Grid item>
      <Typography>{children}</Typography>
    </Grid>
  </Grid>
);
